import React, {Component} from 'react';
import ReactDOM from 'react-dom';
//import {Link} from 'react-router-dom';

class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      formName: '',
      formMail: '',
      formSubject: '',
      formText: '',
      sended: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
    event.target.style.removeProperty("background-color");
    event.target.style.removeProperty("border-color");

  }

  handleSubmit(event) {
    if(!this.state.sended) {
    function validateEmail(email) {
        var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    console.log(this.state.formText);
    var errorCheck = true;

    if(this.state.formName === "" || this.state.formSubject === "" || this.state.formMail === ""  || this.state.formText === "" ) {
      alert("Please fill all inputs!");
      errorCheck = false;

      if(this.state.formName === "") {
        ReactDOM.findDOMNode(this.refs.name).style.backgroundColor = "#ffe5e3";
        ReactDOM.findDOMNode(this.refs.name).style.borderColor = "red";
      }

      if(this.state.formSubject === "") {
        ReactDOM.findDOMNode(this.refs.fsubject).style.backgroundColor = "#ffe5e3";
        ReactDOM.findDOMNode(this.refs.fsubject).style.borderColor = "red";
      }

      if(this.state.formMail === "") {
        ReactDOM.findDOMNode(this.refs.mail).style.backgroundColor = "#ffe5e3";
        ReactDOM.findDOMNode(this.refs.mail).style.borderColor = "red";
      }

      if(this.state.formText === "") {
        ReactDOM.findDOMNode(this.refs.text).style.backgroundColor = "#ffe5e3";
        ReactDOM.findDOMNode(this.refs.text).style.borderColor = "red";
      }

    }



    if(!validateEmail(this.state.formMail) && errorCheck) {
      alert("Please fill valid email!");
      ReactDOM.findDOMNode(this.refs.mail).style.backgroundColor = "#ffe5e3";
      ReactDOM.findDOMNode(this.refs.mail).style.borderColor = "red";
      errorCheck = false;
    }

    if(errorCheck) {

      //eactDOM.findDOMNode(this.refs.submit).className = "submiting";
      ReactDOM.findDOMNode(this.refs.submit).innerHTML = "<i className=\"fas fa-spinner spin\"></i> Sending";


      fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          formName: this.state.formName,
          formSubject: this.state.formSubject,
          formMail: this.state.formMail,
          formText: this.state.formText
        })
      }).then(res => {
        if(res.ok) {
          return res.json }
        else {
          ReactDOM.findDOMNode(this.refs.submit).className = "submitError";
          ReactDOM.findDOMNode(this.refs.submit).innerHTML = "<i class=\"fas fa-exclamation-triangle\"></i> Error";
        }
      }).then(json => {
        if(json) {
          ReactDOM.findDOMNode(this.refs.submit).className = "submitOk";
          ReactDOM.findDOMNode(this.refs.submit).innerHTML = "<i class=\"fas fa-check\"></i> Sent";
          this.setState({sended: true});
        }
        else {
          ReactDOM.findDOMNode(this.refs.submit).className = "submitError";
          ReactDOM.findDOMNode(this.refs.submit).innerHTML = "<i class=\"fas fa-exclamation-triangle\"></i> Error";
        }
      });;
    }
  } else {
    alert("Already sent!");
  }
    event.preventDefault();
  }
  render() {

    return (
      <div>



    <section>
    <div className="Wrapper">
      <div className="Content Follow">
      <h2>Follow me</h2>
      <ul>
      <li><a href="https://www.facebook.com/PatrikSasOfficial/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i> Facebook</a></li>
      <li><a href="https://www.youtube.com/channel/UCaGj5ycfxmbC0WNu5_L7c3A" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i> Youtube</a></li>
      <li><a href="https://www.instagram.com/patrik_sas/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i> Instagram</a></li>
      </ul>
      <div className="contactForm">
        <h2>Send me a message</h2>
        <form onSubmit={this.handleSubmit}>
          <div className="contactRow">
            <div className="contactForm50">
              <label>Name</label>
              <i className="fas fa-user inputIcon"></i>
              <input type="text" value={this.state.formName} name="formName" onChange={this.handleChange} ref="name"></input>
            </div>

            <div className="contactForm50">
              <label>E-mail</label>
              <i className="fas fa-envelope inputIcon"></i>
              <input type="text"  value={this.state.formMail} name="formMail" onChange={this.handleChange} ref="mail"></input>
            </div>
          </div>

            <div className="contactForm100">
              <label>Subject</label>
              <i className="fas fa-question inputIcon"></i>
              <input type="text"  value={this.state.formSubject} name="formSubject" onChange={this.handleChange} ref="fsubject"></input>
            </div>



          <div className="clear"></div>
          <div className="contactForm100">
            <label>Text</label>
            <textarea value={this.state.formText} name="formText" onChange={this.handleChange}  ref="text"/>
          </div>
          <button type="submit" ref="submit" className="submitWait"><i className="fas fa-share-square" ref="buttonIco"></i> Send</button>

        </form>
      </div>
    </div>
    </div>
  </section></div>);
  }

}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js